'use client';

import { PlotlyChart } from './PlotlyChart';
import { type MetricsSample } from '../types';

interface Props { samples: MetricsSample[]; loading?: boolean }

// TotalRequestProbe is a global metric — every pod observes the same value.
// Collapse to a single line by averaging across pods at each timestamp.
export function TotalRequestsChart({ samples, loading }: Props) {
  const sorted = [...samples].sort((a, b) => a.ts_ms - b.ts_ms);
  const pending = new Map<number, { sum: number; n: number }>();
  for (const s of sorted) {
    const v = s.server_total_requests >= 0 ? s.server_total_requests : null;
    if (v == null) continue;
    const acc = pending.get(s.ts_ms) ?? { sum: 0, n: 0 };
    acc.sum += v;
    acc.n += 1;
    pending.set(s.ts_ms, acc);
  }
  const tsList = Array.from(pending.keys()).sort((a, b) => a - b);
  const x = tsList.map((ts) => new Date(ts));
  const y = tsList.map((ts) => {
    const acc = pending.get(ts)!;
    return acc.sum / acc.n;
  });

  const traces = [{
    x,
    y,
    type: 'scatter' as const,
    mode: 'lines' as const,
    name: 'Total Requests',
    line: { color: '#4cc9f0', width: 1.5 },
    connectgaps: false,
  }];

  return <PlotlyChart traces={traces} yTitle="req/s" perPod={false} loading={loading} />;
}
